<div #comp></div>


// WEBPACK FOOTER //
// E:/GangaJewallery-Final/app.server/systemic.app.server/client/src/main/@systemic/ng-confirmations/components/confirmations/confirmations.component.ts.ConfirmationsComponent.html